import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Publisher from './publisher';
import Genre from './genre';
import Duration from './duration';
import styles from './video-metadata.scss';

function VideoMetadata({ className, video, showPublisher = true }) {
  return (
    <div className={classNames(styles.metaInfo, className)}>
      {showPublisher && (
        <Publisher
          className={styles.metaItem}
          dataHook="video-publisher"
          name={video.publisher}
        />
      )}
      <Genre
        className={styles.metaItem}
        dataHook="video-genre"
        name={video.genre}
      />
      <Duration
        className={styles.metaItem}
        dataHook="video-duration"
        value={video.durationStr}
      />
    </div>
  );
}

VideoMetadata.propTypes = {
  video: PropTypes.object.isRequired,
  className: PropTypes.string,
  showPublisher: PropTypes.bool,
};

export default VideoMetadata;
